import React, { Component, createRef, Fragment } from "react";
import {
  Hero,
  Title,
  TechniqueTitle,
  ClientTag,
  CaseWrapper,
  BackButton,
  BackArrow
} from "../styles/Case.styles";

import Reveal from 'react-reveal/Reveal';
import { withRouter } from "react-router";
import Footer from '../components/Footer';
import { Efectr, Efectr1, Efectr2  } from "../styles/effect.styles";

export const ScrollTop = ({ children, location }) => {
  React.useEffect(() => window.scrollTo(0, 0), [location])
  return children
}

class Case extends Component {
  constructor(props) {
    super(props);
    this.introRef = createRef();

    this.state = {
          toBack: false,
          introTop: 0,
          hasBackground: false,
          animateCase: ""
        };
      }
    
      componentDidUpdate() {
        if (this.state.toBack) {
          setTimeout(() => {
            this.props.setNavBackground(false);
            this.props.history.push("/blog");
          }, 400);
        }
        if (this.state.animateCase) {
          setTimeout(() => {
            this.props.setNavBackground(false);
    
            this.props.history.push(this.state.animateCase);
            window.scrollTo(0, 0);
          }, 400);
        }
      }
    
    
      render() {
        return (
          <Fragment>
          <Efectr/>
          <Efectr1/>
          <Efectr2/>
          <ScrollTop>
            <CaseWrapper>
              <Reveal effect="fadeIn">
                <Hero className='mainhero' style={{ backgroundImage: "url('./img/news/MagLrg.png')" }}>
                    <div className='herocaption'>
                      <BackButton className='backdetail'
                        onClick={() => this.setState({ toBack: true, hasBackground: false })}
                        toBack={this.state.toBack}
                        hasBackground={this.state.hasBackground}>
                        <BackArrow src="./img/back.png" alt="Back to blog" />
                        <span>Back </span>
                      </BackButton>
                      <div className='container'>
                        <div className='row'>
                          <div className='col-md-12 pl-md-0'>
                            <ClientTag className='date'>April 8, 2024</ClientTag>
                            <Title>0mg = Magnesium Deficiency</Title>
                            <TechniqueTitle>
                            Magnesium is one of the most common nutrient deficiencies 
                            </TechniqueTitle>
                          </div>
                        </div>
                      </div>
                    </div>
                </Hero>
              </Reveal>
    
              <section className='container' id='detailproject'>
                <div className='row'>
                  <div className='col-md-12'>
                    <p className='content'>Magnesium is an essential micronutrient that is necessary 
                        for many biological and biochemical processes within the body. It helps to 
                        regulate your muscle & nerve function, aids in protein synthesis & bone formation, 
                        controls blood glucose levels, and regulates blood pressure. It is additionally 
                        required for cellular energy production.</p>
                    <p className='content'>While foods like pumpkin seeds, leafy greens, beans, legumes and 
                        whole grains contain magnesium naturally, the average North American diet often lack 
                        sufficient amounts. Additionally, multivitamins lack sufficient amounts of magnesium 
                        and some pharmaceuticals interfere with its absorption. For these reasons, magnesium 
                        is a common nutrient deficiency. To add, individuals with gastrointestinal disease, 
                        type 2 diabetes, and/ or alcohol dependence are more likely to be deficient in magnesium. </p>
                     <p className='content'> If you ever feel fatigue, weakness, muscle cramps, personality 
                        changes and/or abnormal heart rhythms. You could be magnesium deficient!</p>

                  
                    <h3 className='my-5'>What form of Magnesium is right for you?</h3>
                    <div>
                      <p className='content'>1. Magnesium bisglycinate: Muscle & nerve relaxation</p>
                      <p className='content'> 2. Magnesium citrate: Digestion & regularity </p>
                      <p className='content'>3. Magnesium taurate: Heart, blood sugar, blood pressure & inflammation </p>
                      <p className='content'> 4. Magnesium malate: Fibromyalgia, chronic fatigue, & tension migraines</p>
                      <p className='content'>5. Expert help: Speak with your naturopathic doctor to learn more about the right form and dose of magnesium for you!</p>
                    </div>
                  </div>  

                  <div className='col-md-12'></div>
                  <div className='share'>
                    <span className='heading'>
                    Share this blog post :
                    </span>
                    <span className='content'> 
                    <a href="https://www.facebook.com/sharer/sharer.php?u=drmichellemaliknd.com/WOW4" target="_blank" rel="noopener noreferrer">  
                      <i className="fa fa-facebook-f"></i>
                      </a>  
                    </span>
                    <span className='content'> 
                    <a href="https://www.instagram.com/dr.michellemalik.nd" target="_blank" rel="noopener noreferrer">   
                      <i className="fa  fa-instagram"></i>
                      </a>
                    </span>
                  </div>
                </div>
              </section>

            </CaseWrapper>
    
          </ScrollTop>
    
          <Footer />
    
          </Fragment>
        );
      }
    }
    
    export default withRouter(Case);